import axios from "axios";
export var fetchPolizaComments = function fetchPolizaComments(poliza_id) {
  return axios.get("/api/v1/poliza_comments/", {
    params: {
      poliza_id: poliza_id
    },
    timeout: 5000 // 5 segundos timeout

  }).then(function (response) {
    return response.data;
  })["catch"](function (error) {
    // Si es un error 500 o timeout, retornar array vacío para que no bloquee la UI
    if (error.code === 'ECONNABORTED' || error.response && error.response.status === 500) {
      return {
        poliza_comments: []
      };
    }

    throw error;
  });
};
export var createPolizaComment = function createPolizaComment(poliza_comment, token) {
  // Filtrar valores vacíos
  var cleanData = {
    poliza_id: poliza_comment.poliza_id,
    content: poliza_comment.content
  };

  if (poliza_comment.management_type && poliza_comment.management_type.trim() !== "") {
    cleanData.management_type = poliza_comment.management_type;
  }

  if (poliza_comment.contact_method && poliza_comment.contact_method.trim() !== "") {
    cleanData.contact_method = poliza_comment.contact_method;
  }

  if (poliza_comment.next_step && poliza_comment.next_step.trim() !== "") {
    cleanData.next_step = poliza_comment.next_step;
  }

  if (poliza_comment.status && poliza_comment.status.trim() !== "") {
    cleanData.status = poliza_comment.status;
  }

  var headers = {
    "Content-Type": "application/json",
    "Accept": "application/json"
  };

  if (token) {
    headers["X-CSRF-Token"] = token;
  } else {
    // Obtener token del meta tag si no se proporciona
    var metaToken = document.querySelector('meta[name="csrf-token"]');

    if (metaToken) {
      headers["X-CSRF-Token"] = metaToken.getAttribute("content");
    }
  }

  return axios.post("/api/v1/poliza_comments", {
    poliza_comment: cleanData
  }, {
    headers: headers
  });
};
export var updatePolizaComment = function updatePolizaComment(poliza_comment, token) {
  // Enviar todos los campos con sus valores tal cual
  // Si un campo es undefined, no se incluye (no se envía, mantiene el valor actual en el backend)
  // Si es null, se envía como null
  // Si es string vacío "", se convierte a null (usuario borró el campo)
  // Si es string con valor, se envía tal cual
  var cleanData = {
    content: poliza_comment.content || ""
  }; // Solo incluir campos si están definidos (undefined significa "no cambiar")
  // Si está definido, convertir string vacío a null, mantener null si es null, o enviar string con valor

  if (poliza_comment.management_type !== undefined) {
    cleanData.management_type = poliza_comment.management_type === "" || poliza_comment.management_type === null ? null : poliza_comment.management_type;
  }

  if (poliza_comment.contact_method !== undefined) {
    cleanData.contact_method = poliza_comment.contact_method === "" || poliza_comment.contact_method === null ? null : poliza_comment.contact_method;
  }

  if (poliza_comment.next_step !== undefined) {
    cleanData.next_step = poliza_comment.next_step === "" || poliza_comment.next_step === null ? null : poliza_comment.next_step;
  }

  if (poliza_comment.status !== undefined) {
    cleanData.status = poliza_comment.status === "" || poliza_comment.status === null ? null : poliza_comment.status;
  }

  var headers = {
    "Content-Type": "application/json",
    "Accept": "application/json"
  };

  if (token) {
    headers["X-CSRF-Token"] = token;
  } else {
    // Obtener token del meta tag si no se proporciona
    var metaToken = document.querySelector('meta[name="csrf-token"]');

    if (metaToken) {
      headers["X-CSRF-Token"] = metaToken.getAttribute("content");
    }
  }

  return axios.put("/api/v1/poliza_comments/".concat(poliza_comment.id), {
    poliza_comment: cleanData
  }, {
    headers: headers
  }).then(function (response) {
    return response;
  });
};
export var deletePolizaComment = function deletePolizaComment(id, token) {
  var headers = {
    "Accept": "application/json"
  };

  if (token) {
    headers["X-CSRF-Token"] = token;
  } else {
    // Obtener token del meta tag si no se proporciona
    var metaToken = document.querySelector('meta[name="csrf-token"]');

    if (metaToken) {
      headers["X-CSRF-Token"] = metaToken.getAttribute("content");
    }
  }

  return axios["delete"]("/api/v1/poliza_comments/".concat(id), {
    headers: headers
  });
};
export var fetchPolizaComment = function fetchPolizaComment(id) {
  return axios.get("/api/v1/poliza_comments/".concat(id), {
    timeout: 5000
  }).then(function (response) {
    return response.data;
  })["catch"](function (error) {
    if (error.code === 'ECONNABORTED' || error.response && error.response.status === 500) {
      throw new Error("Error al obtener el comentario");
    }

    throw error;
  });
};
export var getIndexQueryKey = function getIndexQueryKey(poliza_id) {
  return ["/api/v1/poliza_comments/".concat(poliza_id)];
};